import type { Appointment } from '@/api/appointments/appointmentsApi.types';
import type { ExternalCalendarEvent } from '@/api/calendarSync/calendarSyncApi.types';

export type CalendarViewMode = 'month' | 'week' | 'day';

export const CALENDAR_VIEW_MODES: CalendarViewMode[] = ['month', 'week', 'day'];

export interface MonthViewProps {
  currentDate: Date;
  selectedDate: Date;
  appointments: Appointment[];
  onDaySelected: (day: Date) => void;
}

export interface WeekViewProps {
  currentDate: Date;
  selectedDate: Date;
  appointments: Appointment[];
  externalEvents: ExternalCalendarEvent[];
  onAppointmentSelected: (appointment: Appointment) => void;
}

export interface DayViewProps {
  currentDate: Date;
  appointments: Appointment[];
  externalEvents: ExternalCalendarEvent[];
  onAppointmentSelected: (appointment: Appointment) => void;
}

export interface DayDetailsPanelProps {
  selectedDate: Date;
  appointmentsForSelectedDate: Appointment[];
  onClose: () => void;
  onEditAppointment: (appointment: Appointment) => void;
  onPreviewAppointment: (appointment: Appointment) => void;
  onOpenSessionNote: (appointment: Appointment) => void;
  onAddAppointment: (date: Date) => void;
}

export interface AppointmentModalProps {
  appointmentToEdit: Appointment | null;
  initialDate: Date;
  appointments: Appointment[];
  externalEvents: ExternalCalendarEvent[];
  onClose: () => void;
}
